module.exports = {
      id: "d8f79b6c02a982041d9e83e286d79ff2roofShape-mansard.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#d8f79b6c02a982041d9e83e286d79ff2roofShape-mansard.svg",
      toString: function () {
        return this.url;
      }
    }